import React, { Component } from 'react'
import { StaticBox, FlowTable } from 'components/basic'
import http from 'API/http'

class MacAddressTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      macaddresstable: null,
      error: false,
      loading: true
    }
  }
  componentDidMount () {
    this.getMacAddressTable(this.props.id)
  }
  componentWillReceiveProps (props) {
    if (props.updated === this.props.updated) return
    this.setState({loading: true})
    this.getMacAddressTable(props.id)
  }
  async getMacAddressTable (id) {
    var [err, res] = await http.get('2.4/tech/access/' + id + '/link/macaddresstable')
    if (err) return this.setState({error: true, cause: res.cause, loading: false})
    this.setState({macaddresstable: res.data, loading: false})
  }
  reload () {
    this.setState({loading: true})
    this.getMacAddressTable(this.props.id)
  }
  render () {
    return (
      <StaticBox dataLoading={this.state.loading} title='Mac Table' icon='microchip' buttons={[{ icon: (this.state.loading ? 'fa-refresh fa-spin' : 'fa-refresh'), event: () => this.reload(), disabled: this.state.loading}]}>
        {this.state.macaddresstable &&
          <pre className='no-overflow mt-10 no-padding'>
            <FlowTable noClass data={this.state.macaddresstable.map(mac => [
              mac.mac,
              mac.serviceType
            ])}>
              <tr>
                <th>Mac</th>
                <th>Service Type</th>
              </tr>
            </FlowTable>
          </pre>
        }
        {this.state.error &&
          <pre className='table-pre mt-10'>
            <div className='error-wrapper'>
              <span><i className='fa fa-fw fa-exclamation-triangle' /> <b>Error fetching MAC-table {this.state.error.cause ? '- ' + this.state.error.cause : ''}</b></span>
            </div>
          </pre>
        }
      </StaticBox>
    )
  }
}
export default MacAddressTable



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/troubleshooting/MacAddressTable.js